<template>
  <div
    class="relative my-4 flex cursor-pointer items-center justify-center select-none"
  >
    <div class="z-10 w-auto bg-disabled px-2 whitespace-nowrap">
      <span
        class="rounded-full bg-blue-200/50 px-2 py-1 text-xs font-semibold text-blue-500 uppercase"
      >
        {{ $t("ORGANIZATION.DO_ADD_COND_GROUP") }}
      </span>
    </div>
    <div class="absolute top-1/2 h-0-25 w-full bg-gray-300" />
  </div>
</template>
